// extracted by mini-css-extract-plugin
export const header = "header-module--header--1vtNk";
export const offTop = "header-module--offTop--3GORZ";
export const headerContent = "header-module--headerContent--sOwLE";
export const headerCentered = "header-module--headerCentered--3-vtz";
export const headerSide = "header-module--headerSide--1sJ1P";
export const icon = "header-module--icon--2gSjv";